var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 7",
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    x2: 31,
    y1: 29,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    x2: 31,
    y1: 45,
    y2: 45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 12,
    x: 15,
    y: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,8v4l6.54,6.54A5,5,0,0,1,33,22.07V29H31V45h2V60a2,2,0,0,1-2,2H11a2,2,0,0,1-2-2V45h2V29H9V22.07a5,5,0,0,1,1.46-3.53L17,12V8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 21,
    cy: 37,
    rx: 6,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 30,
    width: 18,
    x: 37,
    y: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37,
    x2: 55,
    y1: 58,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37,
    x2: 55,
    y1: 38,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51,
    x2: 51,
    y1: 41,
    y2: 51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51,
    x2: 51,
    y1: 53,
    y2: 55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "51 32 51 26 55 22"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.cd2787f8a1adfec1a166b38bd9977747.svg";
export { ForwardRef as ReactComponent };